/* unplugin-vue-components disabled */import { render } from "./PasswordNotificationDialog.vue?vue&type=template&id=0a0f2634&scoped=true&ts=true"
import script from "./PasswordNotificationDialog.vue?vue&type=script&lang=ts"
export * from "./PasswordNotificationDialog.vue?vue&type=script&lang=ts"

import "./PasswordNotificationDialog.vue?vue&type=style&index=0&id=0a0f2634&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a0f2634"]])

export default __exports__